import * as React from 'react'

import { Address } from 'src/types/schema/graphql'

interface IAddressRow {
    address: Address
}

const AddressRow: React.FC<IAddressRow> = ({ address }) => {
    return (
        <div className='lg:text-normal md:text-md flex w-auto flex-wrap space-x-1 text-sm text-gray-400 md:flex-row'>
            {address?.street && <span>{address?.street},</span>}
            {address?.street2 && <span>{address?.street2},</span>}
            {address?.city && <span>{address?.city},</span>}
            {address?.state && <span>{address?.state}</span>}
            {address?.postalCode && <span>{address?.postalCode}</span>}
        </div>
    )
}

export default AddressRow
